module.exports = __webpack_public_path__ + "img/product_50.8023adb.webp";